import React from 'react';

type Props = {
  color?: string,
  onClick?: () => void,
} & typeof defaultProps;

const defaultProps = {
  color: '#7E7E7E',
  onClick: () => { },
};
const SaveIcon = function SaveIcon(props: Props) {
  const { color, onClick } = props;
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="save-icon-svg" onClick={onClick}>
      <path fillRule="evenodd" clipRule="evenodd" d="M14.76 4.70667L12.2 2.18667C12.08 2.07778 11.92 2 11.76 2H11.7333H6.21333H3.66667C3.29333 2 3 2.34222 3 2.77778V15.2222C3 15.6578 3.29333 16 3.66667 16H14.3333C14.7067 16 15 15.6578 15 15.2222V5.31333C15 5.08 14.9067 4.86222 14.76 4.70667ZM11.08 3.55554V7.56888H6.87994V3.55554H11.08ZM4.33327 14.4444H13.6666V5.65554L12.4133 4.42665V8.34665C12.4133 8.78221 12.1199 9.12443 11.7466 9.12443H6.21327C5.83993 9.12443 5.5466 8.78221 5.5466 8.34665V3.55554H4.33327V14.4444Z" fill={color} />
      <path d="M10.0629 6.36C10.4915 6.36 10.8344 5.96 10.8344 5.46V3.9C10.8344 3.4 10.4915 3 10.0629 3C9.63436 3 9.2915 3.4 9.2915 3.9V5.46C9.2915 5.96 9.6515 6.36 10.0629 6.36Z" fill={color} />
    </svg>
  );
};
SaveIcon.defaultProps = defaultProps;
export default SaveIcon;
